// extracted by mini-css-extract-plugin
export default {"pageTitle":"WidgetHeader_pageTitle__d53eK","logo":"WidgetHeader_logo__DnlMS"};